import React, { useEffect, useState, useRef } from 'react';
import './HRLServicesUtility.css'
import { Link } from 'react-router-dom';
import SubscribeForm from '../SubscribeFormFolder/SubscribeForm';
import {
    LazyLoadImage,
    LazyLoadComponent,
} from 'react-lazy-load-image-component';
import { useLocation } from "react-router-dom";

// Assets
// Background video
const BannerBg = require('./videos/utility-page-video.mp4');
const BannerBg_LazyLoadImg = require('./img/utility-lazyload.png');

// Gifs
import slide1 from './img/Vegetation_Management_1.webp'
import slide2 from './img/Vegetation_Management_2.webp'
import slide3 from './img/Asset_Hardening_1.webp'
import slide4 from './img/Asset_Hardening_2.webp'
import slide5 from './img//Real-Time_Situational_Awareness_1.webp'
import slide6 from './img/Real-Time_Situational_Awareness_2.webp'
import slide7 from './img/Real-Time_Situational_Awareness_3.webp'


// Hero button images
import whiteTree from './img/ai-white.png'
import blueTree from './img/ai-blue.png'
import whiteHeli from './img/emergency-white.png'
import blueHeli from './img/emergency-blue.png'
import laptopMock from './img/laptop-mockup1.png'
import papers from './img/utility-pages.png'
import utilitImg1 from './img/utility-bg1.webp'

// Icons
import { FaArrowRight } from "react-icons/fa6";
import { FiDownload } from "react-icons/fi";

export type DownloadableDocs = {
    docName: string;
    type: string;
    file: any;
    datetime: string;
};

const HRLServicesUtility = () => {

    // Varialble to auto-scroll to subscribe form
    const subscribeRef = useRef<HTMLDivElement>(null);
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("scrollToSubscribe") === "true" && subscribeRef.current) {
            // Delay to let images/video load
            setTimeout(() => {
                const yOffset = 0; // tweak if needed
                const y = subscribeRef.current!.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });

                // Remove the query parameter from URL without reloading
                const newUrl = location.pathname;
                window.history.replaceState({}, '', newUrl);
            }, 300);
        }
    }, [location]);


    // Section for the video and its lazyLoad functionality
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);

    // Hero button hover logic
    const [hoveredCard, setHoveredCard] = useState<"land" | "air" | null>(null);
    const wildfireRef = useRef<HTMLHeadingElement>(null);
    const foreflightRef = useRef<HTMLDivElement>(null);

    const [doc, setDoc] = useState<DownloadableDocs[]>([]);
    const [showInput, setShowInput] = useState(false);
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const SECTIONS = [
        {
            key: "vegetation",
            label: "Vegetation Management",
            slides: [
                {
                    title: "Vegetation Management",
                    description: "FNN™ integrates each utility’s vegetation management activities, including trimming cycles, fuel-load reduction efforts, and feeder-level mitigation work, with its AI-driven Wildfire Hazard Risk Model. This alignment provides a measurable view of how individual actions reduce ignition risk along power assets, establishing a clear and defensible record of how vegetation management programs lower wildfire exposure across the grid.",
                    image: slide1,
                },
                {
                    title: "Vegetation Management",
                    description: "FNN™ integrates each utility’s vegetation management activities, including trimming cycles, fuel-load reduction efforts, and feeder-level mitigation work, with its AI-driven Wildfire Hazard Risk Model. This alignment provides a measurable view of how individual actions reduce ignition risk along power assets, establishing a clear and defensible record of how vegetation management programs lower wildfire exposure across the grid.",
                    image: slide2,
                },
            ],
        },
        {
            key: "asset",
            label: "Asset Hardening",
            slides: [
                {
                    title: "Asset Hardening",
                    description: "Asset-hardening investments, such as covered conductor, pole replacements, rapid-reset reclosers, undergrounding, and other system upgrades, are seamlessly integrated into FNN™’s AI-driven Wildfire Hazard Model. The Wildfire Hub translates these improvements into a clear, real-time view of how each investment reduces risk across feeders, laterals, and substations. This enables utilities to prioritize capital projects with confidence, demonstrate measurable risk reduction, and present a defensible standard of care for both regulatory review and strategic planning.",
                    image: slide3,
                },
                {
                    title: "Asset Hardening",
                    description: "Asset-hardening investments, such as covered conductor, pole replacements, rapid-reset reclosers, undergrounding, and other system upgrades, are seamlessly integrated into FNN™’s AI-driven Wildfire Hazard Model. The Wildfire Hub translates these improvements into a clear, real-time view of how each investment reduces risk across feeders, laterals, and substations. This enables utilities to prioritize capital projects with confidence, demonstrate measurable risk reduction, and present a defensible standard of care for both regulatory review and strategic planning.",
                    image: slide4,
                },
            ],
        },
        {
            key: "situational",
            label: "Real-Time Situational Awareness",
            slides: [
                {
                    title: "Situational Awareness",
                    description: "The Wildfire Hub simultaneously tracks all active fires, incorporates verified incident reports, and leverages FNN™’s AI-driven analysis of satellite-derived burn-scar and fire-spread data. This integrated, multi-layered perspective provides utilities with precise insight into fire origins, progression, and at-risk assets, supporting timely, data-driven decision-making during critical operations. FNN™ also delivers real-time situational awareness by mapping lightning-ignited fire potential through its proprietary High-Risk-Lightning™ (HRL™) sensors, capable of detecting long-continuing-current strikes that can trigger wildfires. ",
                    image: slide5,
                },
                {
                    title: "Situational Awareness",
                    description: "The Wildfire Hub simultaneously tracks all active fires, incorporates verified incident reports, and leverages FNN™’s AI-driven analysis of satellite-derived burn-scar and fire-spread data. This integrated, multi-layered perspective provides utilities with precise insight into fire origins, progression, and at-risk assets, supporting timely, data-driven decision-making during critical operations. FNN™ also delivers real-time situational awareness by mapping lightning-ignited fire potential through its proprietary High-Risk-Lightning™ (HRL™) sensors, capable of detecting long-continuing-current strikes that can trigger wildfires. ",
                    image: slide6,
                },
                {
                    title: "Situational Awareness",
                    description: "The Wildfire Hub simultaneously tracks all active fires, incorporates verified incident reports, and leverages FNN™’s AI-driven analysis of satellite-derived burn-scar and fire-spread data. This integrated, multi-layered perspective provides utilities with precise insight into fire origins, progression, and at-risk assets, supporting timely, data-driven decision-making during critical operations. FNN™ also delivers real-time situational awareness by mapping lightning-ignited fire potential through its proprietary High-Risk-Lightning™ (HRL™) sensors, capable of detecting long-continuing-current strikes that can trigger wildfires. ",
                    image: slide7,
                },
            ],
        },
    ];


    function ActionSlides() {
        const [activeSection, setActiveSection] = useState(0);
        const [activeImage, setActiveImage] = useState(0);
        const [isAnimating, setIsAnimating] = useState(false);
        const [direction, setDirection] = useState<"next" | "prev">("next");


        const section = SECTIONS[activeSection];
        const slide = section.slides[activeImage];

        const changeSection = (index: number) => {
            if (index === activeSection) return;

            setIsAnimating(true);
            setTimeout(() => {
                setActiveSection(index);
                setActiveImage(0); // reset image when section changes
                setIsAnimating(false);
            }, 250);
        };

        const changeImage = (index: number) => {
            if (index === activeImage) return;

            setDirection(index > activeImage ? "next" : "prev");
            setIsAnimating(true);

            setTimeout(() => {
                setActiveImage(index);
                setIsAnimating(false);
            }, 250); // MUST match CSS timing
        };


        return (
            <div className="action-section action-in-utility slide-container">

                {/* SECTION HEADER (tabs) */}
                <div className="utility-action-header">
                    {SECTIONS.map((s, i) => (
                        <button
                            key={s.key}
                            className={i === activeSection ? "active" : ""}
                            onClick={() => changeSection(i)}
                        >
                            {s.label}
                        </button>
                    ))}
                </div>

                {/* SLIDE CONTENT */}
                {/* <div
                    className={`slide-content ${isAnimating ? "slide-out" : "slide-in"} ${direction}`}
                > */}
                <div className="slide-content">
                    <div className="utility-action-content">
                        <div className="action-info-wrapper utility-slide-text">
                            <h1 className="the-h1">{slide.title}</h1>
                            <h2 className="the-h2">{slide.description}</h2>
                        </div>

                        <div className="utility-image-wrapper">
                            <div
                                className={`utility-image-animator ${isAnimating ? "slide-out" : "slide-in"
                                    } ${direction}`}
                            >
                                <img
                                    className="action-image utility-slide-image"
                                    alt={slide.title}
                                    src={slide.image}
                                />
                            </div>

                            {/* IMAGE DOT NAVIGATION */}
                            <div className="slide-dots">
                                {section.slides.map((_, i) => (
                                    <span
                                        key={i}
                                        className={`dot ${i === activeImage ? "active" : ""}`}
                                        onClick={() => changeImage(i)}
                                    />
                                ))}
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        );
    }

    const fetchDocs = async () => {
        try {
            const response = await fetch('/api/downloadable_pdf/', {
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data: DownloadableDocs[] = await response.json();
            setDoc(data); // Assign the fetched posts to state
        } catch (err) {
            // Type assertion to 'Error' to access the message property
            if (err instanceof Error) {
                setError(err.message); // Handle error
            } else {
                setError('An unknown error occurred'); // Fallback for unknown errors
            }
        }
    };

    useEffect(() => {
        fetchDocs();
    }, []); // Empty dependency array to run once on mount


    const handleDownloadClick = () => {
        setShowInput(true);
    };

    const handleUtilityDownloadOnly = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            if (!email) return;

            // Send email to backend for "utility" subscription without triggering automations
            const response = await fetch('/api/subscribe/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, industry: 'utility', skipNewsletter: true }), // add a flag
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Subscription failed');

            setSubmitted(true);
            setError('');
            setShowInput(false);

            // Trigger PDF download immediately in new tab
            const mostRecentAIDoc = doc
                .filter(d => d.type === 'AI')
                .sort((a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime())[0];

            if (mostRecentAIDoc?.file) {
                window.open(mostRecentAIDoc.file, '_blank', 'noopener,noreferrer');
            }

            // Reset email after 6 seconds
            setTimeout(() => {
                setSubmitted(false);
                setEmail('');
            }, 6000);

        } catch (err: any) {
            console.error(err);
            setError(err.message || 'Something went wrong.');
        }
    };



    return (
        <div className="detector-container">

            {/* Cover Section */}
            <div className="detector-hero-section">
                {!isVideoLoaded && (
                    <LazyLoadComponent
                        placeholder={<img src={BannerBg_LazyLoadImg} alt="" />}
                    >
                        <LazyLoadImage
                            src={BannerBg_LazyLoadImg}
                            alt="="
                            className="hero-image"
                        />
                    </LazyLoadComponent>
                )}

                <video
                    className={`hero-image ${isVideoLoaded ? '' : 'hidden'}`}
                    src={BannerBg}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onLoadedData={() => setIsVideoLoaded(true)}
                />

                <div className="dark-overlay"></div> {/* ← Overlay */}

                <div className="utility-hero-info-wrapper">
                    <h1><strong> Utility  <br />Solutions</strong></h1>

                    <div className='land-air-cards'>
                        <div
                            className='land-air-card1 opa'
                            onMouseEnter={() => setHoveredCard('land')}
                            onMouseLeave={() => setHoveredCard(null)}
                            onClick={() => {
                                if (foreflightRef.current) {
                                    const yOffset = 0; // scroll 80px above the element
                                    const y = foreflightRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                    window.scrollTo({ top: y, behavior: 'smooth' });
                                }
                            }}
                        >
                            <img
                                className="land-air-img"
                                alt="tree"
                                src={hoveredCard === 'land' ? blueTree : whiteTree}
                            />
                            <p>Wildfire Mitigation Plans </p>
                        </div>
                        <div
                            className='land-air-card1 opb'
                            onMouseEnter={() => setHoveredCard('air')}
                            onMouseLeave={() => setHoveredCard(null)}
                            onClick={() => {
                                if (wildfireRef.current) {
                                    const yOffset = -45; // scroll 80px above the element
                                    const y = wildfireRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                    window.scrollTo({ top: y, behavior: 'smooth' });
                                }
                            }}
                        >
                            <img
                                className="land-air-img3"
                                alt="heli"
                                src={hoveredCard === 'air' ? blueHeli : whiteHeli}
                            />
                            <p>FNN™ Wildfire Hub</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Precision Section */}
            <div className="detector-hero-section">
                <img className="hero-image1" alt="hero background" src={utilitImg1} />
                <div className="dark-overlay"></div> {/* ← Overlay */}

                <div className={`precision-info-wrapper align-left`}>
                    <div className="precision-infos">
                        <h1><strong>Minimize Risk & Liability</strong></h1>
                        <h2>
                            Wildfires sparked by electric utility infrastructure pose a growing risk to communities across the U.S. As these events increase, utilities face
                            rising exposure to liability, making it essential to<span className='glow-blue'> determine fire cause and understand impacts on assets</span> and surrounding communities.
                        </h2>

                        <Link to="/contact" className='the-utility-button'>
                            <span>Learn More</span>
                        </Link>

                    </div>
                </div>
            </div>

            {/* High Risk Section */}
            <div className="high-risk-section" ref={foreflightRef}>
                <div className='high-risk-info-wrapper'>
                    <h1 className='the-h1'>Wildfire Mitigation Plans</h1>

                    <h2 className='the-h2'>The utility industry is moving toward stronger, data-driven wildfire risk management, raising expectations for a higher
                        <span className='glow-blue'> standard of care</span>. To avoid negligence findings, utilities must demonstrate proactive decisions supported
                        by the best available intelligence. <span className='glow-blue'>AI-driven ignition analytics </span> and<span className='glow-blue'> verified situational awareness </span> are now essential components of defensible Wildfire Mitigation Plans.</h2>

                    <Link to="/contact" className='the-button'>
                        <span>Learn More</span>
                    </Link>
                </div>
            </div>

            {/* Downlod Section */}
            <div className='whitePaper-section-parent'>
                <div className='wildfire-card'>
                    <div className='wildfire-info-wrapper'>
                        <h1 className='the-wild-h1'>Wildfire Mitigation Plan Essentials</h1>
                        <h2 className='the-h2'>
                            Download FNN™’s whitepaper to see how a Wildfire Mitigation Plan
                            can define your standard of care and safeguard your organization
                            from wildfire risk and liability.
                        </h2>

                        {submitted ? (
                            <div className="download-message">
                                <h1>Download successful!</h1>
                            </div>
                        ) : showInput ? (
                            <form className="download-input-wrapper" onSubmit={handleUtilityDownloadOnly}>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    className="subs-input"
                                    value={email}
                                    required
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <button className="the-paper-button" type="submit">
                                    Download <FaArrowRight />
                                </button>
                            </form>
                        ) : (
                            <button className="the-paper-button" onClick={handleDownloadClick}>
                                Download <FaArrowRight />
                            </button>
                        )}

                    </div>

                    <div className='papers-and-download'>
                        <img className="papers-image" alt="action background" src={papers} />
                        <button
                            className='paper-download-button'
                            onClick={handleDownloadClick}>
                            <FiDownload className='dw-icon' />
                        </button>
                    </div>
                </div>
            </div>

            {/* Wildfire Hub Section */}
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                <div className="high-risk-section responsive-order">
                    <div className='high-risk-info-wrapper'>
                        <h1 className='the-h1' ref={wildfireRef}>FNN™ Wildfire Hub</h1>

                        <h2 className='the-h2'>For utilities, proving a defensible standard of care is essential. The FNN™ Wildfire Hub creates
                            a time-stamped record across the <span className='glow-blue'> three pillars</span> of wildfire risk management, combining
                            <span className='glow-blue'> vegetation management guided by a dynamic wildfire hazard model</span>, <span className='glow-blue'>asset hardening with clear
                                insight into how grid improvements reduce ignition risk</span>, and <span className='glow-blue'> real-time situational awareness of utility-caused lightning-ignited
                                    and other fires</span>. Together, these capabilities form a verifiable history of proactive, data-driven decisions
                            that protect both assets and communities.
                        </h2>
                    </div>

                    <Link to="/contact" className='the-utility-button'>
                        <span>Learn More</span>
                    </Link>
                </div>

                {/* Laptop section */}
                {/* <img className="laptop-image" alt="action background" src={laptopMock} /> */}
            </div>

            {/* Slides Section */}
            <ActionSlides />


            <div ref={subscribeRef} style={{width:'100%'}}>
                <SubscribeForm />
            </div>


        </div>
    )
}

export default HRLServicesUtility